import { render, staticRenderFns } from "./IpadModal.vue?vue&type=template&id=904df41e&scoped=true&"
import script from "./IpadModal.vue?vue&type=script&lang=js&"
export * from "./IpadModal.vue?vue&type=script&lang=js&"
import style0 from "./IpadModal.vue?vue&type=style&index=0&id=904df41e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904df41e",
  null
  
)

export default component.exports